function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import * as Cookies from 'js-cookie';

var CookieStorage =
/*#__PURE__*/
function () {
  function CookieStorage(data) {
    _classCallCheck(this, CookieStorage);

    this.path = '/';
    this.expires = 365;
    this.secure = false;
  }

  _createClass(CookieStorage, [{
    key: "setItem",
    value: function setItem(key, value) {
      Cookies.set(key, value, {
        path: this.path,
        expires: this.expires,
        secure: this.secure
      });
      return Cookies.get(key);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return Cookies.get(key);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return Cookies.remove(key, {
        path: this.path,
        secure: this.secure
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var cookies = Cookies.get();
      var index;

      for (index = 0; index < cookies.length; ++index) {
        Cookies.remove(cookies[index]);
      }

      return {};
    }
  }]);

  return CookieStorage;
}();

export { CookieStorage as default };